import { finalCta, site } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function FinalCta() {
  return (
    <section className="bg-primary-950 py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 text-center md:px-6">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-accent-300">
            Avaliação individual
          </span>
          <h2 className="mt-6 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-5xl">
            {finalCta.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
            {finalCta.text}
          </p>

          <a
            href={site.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-accent-500 px-9 py-4 text-base font-semibold text-background-50 transition-transform duration-300 hover:scale-[1.03]"
          >
            <i className="ri-whatsapp-line text-xl text-[#25D366]" />
            {finalCta.cta}
          </a>

          <p className="mt-6 text-xs uppercase tracking-[0.16em] text-accent-300">
            {finalCta.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}